import {NgForOf, NgIf} from '@angular/common';
import {Component, Input} from '@angular/core';
import {NbTooltipModule} from '@nebular/theme';
import {ProductCustomer} from 'compob2b-libs';

@Component({
    selector: 'app-product-markers',
    imports: [
        NbTooltipModule,
        NgForOf,
        NgIf
    ],
    templateUrl: './product-markers.component.html',
    styleUrl: './product-markers.component.scss'
})
export class ProductMarkersComponent {

  @Input() product: ProductCustomer;
}
